(ns splash.ui.lender-portal.components.mui
  (:refer-clojure :exclude [list])
  (:require
    ["@mui/material/ListSubheader" :as MuiListSubheader]
    ["@mui/x-date-pickers/DatePicker" :as DatePicker]
    ["@mui/x-date-pickers/DateTimePicker" :as DateTimePicker]
    [reagent-mui.lab.loading-button]
    [reagent-mui.lab.tab-context]
    [reagent-mui.lab.tab-panel]
    [reagent-mui.material.accordion]
    [reagent-mui.material.accordion-details]
    [reagent-mui.material.accordion-summary]
    [reagent-mui.material.alert]
    [reagent-mui.material.alert-title]
    [reagent-mui.material.app-bar]
    [reagent-mui.material.autocomplete]
    [reagent-mui.material.avatar]
    [reagent-mui.material.backdrop]
    [reagent-mui.material.badge]
    [reagent-mui.material.bottom-navigation]
    [reagent-mui.material.box]
    [reagent-mui.material.breadcrumbs]
    [reagent-mui.material.button]
    [reagent-mui.material.card]
    [reagent-mui.material.card-actions]
    [reagent-mui.material.card-content]
    [reagent-mui.material.chip]
    [reagent-mui.material.circular-progress]
    [reagent-mui.material.collapse]
    [reagent-mui.material.container]
    [reagent-mui.material.dialog]
    [reagent-mui.material.dialog-actions]
    [reagent-mui.material.dialog-content]
    [reagent-mui.material.dialog-content-text]
    [reagent-mui.material.dialog-title]
    [reagent-mui.material.divider]
    [reagent-mui.material.drawer]
    [reagent-mui.material.fab]
    [reagent-mui.material.form-control]
    [reagent-mui.material.form-control-label]
    [reagent-mui.material.grid]
    [reagent-mui.material.icon]
    [reagent-mui.material.icon-button]
    [reagent-mui.material.input]
    [reagent-mui.material.input-adornment]
    [reagent-mui.material.input-base]
    [reagent-mui.material.input-label]
    [reagent-mui.material.linear-progress]
    [reagent-mui.material.link]
    [reagent-mui.material.list]
    [reagent-mui.material.list-item]
    [reagent-mui.material.list-item-button]
    [reagent-mui.material.list-item-icon]
    [reagent-mui.material.list-item-text]
    [reagent-mui.material.menu]
    [reagent-mui.material.menu-item]
    [reagent-mui.material.paper]
    [reagent-mui.material.popover]
    [reagent-mui.material.radio]
    [reagent-mui.material.select]
    [reagent-mui.material.skeleton]
    [reagent-mui.material.snackbar]
    [reagent-mui.material.stack]
    [reagent-mui.material.step]
    [reagent-mui.material.step-label]
    [reagent-mui.material.stepper]
    [reagent-mui.material.switch-component]
    [reagent-mui.material.tab]
    [reagent-mui.material.table]
    [reagent-mui.material.table-body]
    [reagent-mui.material.table-cell]
    [reagent-mui.material.table-container]
    [reagent-mui.material.table-footer]
    [reagent-mui.material.table-head]
    [reagent-mui.material.table-pagination]
    [reagent-mui.material.table-row]
    [reagent-mui.material.table-sort-label]
    [reagent-mui.material.tabs]
    [reagent-mui.material.text-field]
    [reagent-mui.material.toolbar]
    [reagent-mui.material.tooltip]
    [reagent-mui.material.typography]
    [reagent-mui.styles]
    [reagent-mui.x.data-grid]
    [reagent.core :as r]))

(def theme-provider reagent-mui.styles/theme-provider)
(def create-theme reagent-mui.styles/create-theme)
(def accordion reagent-mui.material.accordion/accordion)
(def accordion-details reagent-mui.material.accordion-details/accordion-details)
(def accordion-summary reagent-mui.material.accordion-summary/accordion-summary)
(def alert reagent-mui.material.alert/alert)
(def alert-title reagent-mui.material.alert-title/alert-title)
(def app-bar reagent-mui.material.app-bar/app-bar)
(def autocomplete reagent-mui.material.autocomplete/autocomplete)
(def box reagent-mui.material.box/box)
(def button reagent-mui.material.button/button)
(def card reagent-mui.material.card/card)
(def card-actions reagent-mui.material.card-actions/card-actions)
(def card-content reagent-mui.material.card-content/card-content)
(def linear-progress reagent-mui.material.linear-progress/linear-progress)
(def circular-progress reagent-mui.material.circular-progress/circular-progress)
(def container reagent-mui.material.container/container)
(def dialog reagent-mui.material.dialog/dialog)
(def dialog-actions reagent-mui.material.dialog-actions/dialog-actions)
(def dialog-content reagent-mui.material.dialog-content/dialog-content)
(def dialog-title reagent-mui.material.dialog-title/dialog-title)
(def dialog-content-text reagent-mui.material.dialog-content-text/dialog-content-text)
(def divider reagent-mui.material.divider/divider)
(def fab reagent-mui.material.fab/fab)
(def grid reagent-mui.material.grid/grid)
(def icon-button reagent-mui.material.icon-button/icon-button)
(def loading-button reagent-mui.lab.loading-button/loading-button)
(def input reagent-mui.material.input/input)
(def input-base reagent-mui.material.input-base/input-base)
(def link reagent-mui.material.link/link)
(def list reagent-mui.material.list/list)
(def list-subheader (r/adapt-react-class (.-default MuiListSubheader)))
(def list-item reagent-mui.material.list-item/list-item)
(def list-item-text reagent-mui.material.list-item-text/list-item-text)
(def list-item-button reagent-mui.material.list-item-button/list-item-button)
(def list-item-icon reagent-mui.material.list-item-icon/list-item-icon)
(def menu reagent-mui.material.menu/menu)
(def menu-item reagent-mui.material.menu-item/menu-item)
(def radio reagent-mui.material.radio/radio)
(def skeleton reagent-mui.material.skeleton/skeleton)
(def snackbar reagent-mui.material.snackbar/snackbar)
(def stack reagent-mui.material.stack/stack)
(def tab reagent-mui.material.tab/tab)
(def tab-panel reagent-mui.lab.tab-panel/tab-panel)
(def tab-context reagent-mui.lab.tab-context/tab-context)
(def table reagent-mui.material.table/table)
(def table-body reagent-mui.material.table-body/table-body)
(def table-cell reagent-mui.material.table-cell/table-cell)
(def table-container reagent-mui.material.table-container/table-container)
(def table-head reagent-mui.material.table-head/table-head)
(def table-row reagent-mui.material.table-row/table-row)
(def tabs reagent-mui.material.tabs/tabs)
(def toolbar reagent-mui.material.toolbar/toolbar)
(def tooltip reagent-mui.material.tooltip/tooltip)
(def typography reagent-mui.material.typography/typography)
(def avatar reagent-mui.material.avatar/avatar)
(def badge reagent-mui.material.badge/badge)
(def data-grid reagent-mui.x.data-grid/data-grid)
(def collapse reagent-mui.material.collapse/collapse)
(def breadcrumbs reagent-mui.material.breadcrumbs/breadcrumbs)
(def drawer reagent-mui.material.drawer/drawer)
(def text-field reagent-mui.material.text-field/text-field)
(def form-control reagent-mui.material.form-control/form-control)
(def select reagent-mui.material.select/select)
(def input-label reagent-mui.material.input-label/input-label)
(def switch reagent-mui.material.switch-component/switch)
(def form-control-label reagent-mui.material.form-control-label/form-control-label)
(def x-date-picker (r/adapt-react-class DatePicker/DatePicker))
(def x-datetime-picker (r/adapt-react-class DateTimePicker/DateTimePicker))
(def backdrop reagent-mui.material.backdrop/backdrop)
(def popover reagent-mui.material.popover/popover)
(def chip reagent-mui.material.chip/chip)
(def input-adornment reagent-mui.material.input-adornment/input-adornment)
(def stepper reagent-mui.material.stepper/stepper)
(def step reagent-mui.material.step/step)
(def step-label reagent-mui.material.step-label/step-label)
(def paper reagent-mui.material.paper/paper)
